/**
 * @generated SignedSource<<5f97fc6a8724c2bc6f90ace84dfe95ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SupplyEfnNumberInput = {
  clientMutationId?: string | null;
  efnNumber: string;
};
export type SupplyEfnForm_SupplyEfnMutation$variables = {
  input: SupplyEfnNumberInput;
};
export type SupplyEfnForm_SupplyEfnMutation$data = {
  readonly InfectopharmAuth: {
    readonly supplyEfnNumber: {
      readonly clientMutationId: string | null;
      readonly userInformation: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"DashboardScreen_UserStatusFragment">;
      };
    } | null;
  };
};
export type SupplyEfnForm_SupplyEfnMutation = {
  response: SupplyEfnForm_SupplyEfnMutation$data;
  variables: SupplyEfnForm_SupplyEfnMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "street",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "brandUrl",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SupplyEfnForm_SupplyEfnMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "InfectopharmAuthMutations",
        "kind": "LinkedField",
        "name": "InfectopharmAuth",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "SupplyEfnNumberPayload",
            "kind": "LinkedField",
            "name": "supplyEfnNumber",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInformation",
                "kind": "LinkedField",
                "name": "userInformation",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DashboardScreen_UserStatusFragment"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SupplyEfnForm_SupplyEfnMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "InfectopharmAuthMutations",
        "kind": "LinkedField",
        "name": "InfectopharmAuth",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "SupplyEfnNumberPayload",
            "kind": "LinkedField",
            "name": "supplyEfnNumber",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInformation",
                "kind": "LinkedField",
                "name": "userInformation",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "salutation",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isLocked",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleApplicationProcess",
                    "kind": "LinkedField",
                    "name": "roleApplicationProcess",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "targetRole",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "privateAddress",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "address",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "company",
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContactDetails",
                        "kind": "LinkedField",
                        "name": "contactDetails",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "faxNumber",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "phoneNumber",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mobileNumber",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userConsentsMobileMarketing",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Brand",
                    "kind": "LinkedField",
                    "name": "accessToBrands",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Brand",
                    "kind": "LinkedField",
                    "name": "signedUpOverBrand",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Newsletter",
                        "kind": "LinkedField",
                        "name": "newsletters",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "registrationDisplayLocations",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "countries",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "limitToRoles",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "brandColorHex",
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "availableRoles",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Newsletter",
                    "kind": "LinkedField",
                    "name": "signedUpToNewsletters",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NewsletterSubscription",
                    "kind": "LinkedField",
                    "name": "newsletterSubscriptions",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Newsletter",
                        "kind": "LinkedField",
                        "name": "newsletter",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "subscribedAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unsubscribedAt",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "efnNumber",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f78432e2e6d82d0a4777837957cef8e0",
    "id": null,
    "metadata": {},
    "name": "SupplyEfnForm_SupplyEfnMutation",
    "operationKind": "mutation",
    "text": "mutation SupplyEfnForm_SupplyEfnMutation(\n  $input: SupplyEfnNumberInput!\n) {\n  InfectopharmAuth {\n    supplyEfnNumber(input: $input) {\n      clientMutationId\n      userInformation {\n        id\n        ...DashboardScreen_UserStatusFragment\n      }\n    }\n  }\n}\n\nfragment AccessToBrands_UserStatusFragment on UserInformation {\n  accessToBrands {\n    id\n    name\n    brandUrl\n    icon {\n      url\n      id\n    }\n  }\n}\n\nfragment AuthScreenBase_UserInformationFragment on UserInformation {\n  id\n  roleApplicationProcess {\n    targetRole\n  }\n  signedUpOverBrand {\n    brandColorHex\n    name\n    brandUrl\n    icon {\n      url\n      id\n    }\n    ...NonAuthScreenBase_BrandFragment\n    id\n  }\n  ...RoleApplicationRegistrationForm_UserInformationFragment\n}\n\nfragment ChangeEmailForm_UserFragment on UserInformation {\n  isLocked\n}\n\nfragment ChangePasswordForm_UserFragment on UserInformation {\n  isLocked\n}\n\nfragment ChangePrivateAddressForm_UserFragment on UserInformation {\n  id\n  roleApplicationProcess {\n    privateAddress {\n      street\n      postalCode\n      city\n      country\n    }\n  }\n}\n\nfragment DashboardScreen_UserStatusFragment on UserInformation {\n  id\n  firstName\n  lastName\n  salutation\n  title\n  isLocked\n  roleApplicationProcess {\n    targetRole\n    status\n    userStatus\n    privateAddress {\n      street\n      postalCode\n      city\n      country\n    }\n  }\n  ...RolesDisplay_UserStatusFragment\n  ...AccessToBrands_UserStatusFragment\n  ...Newsletters_UserStatusFragment\n  ...SupplyEfnForm_UserFragment\n  ...ChangePasswordForm_UserFragment\n  ...ChangeEmailForm_UserFragment\n  ...ChangePrivateAddressForm_UserFragment\n  ...DeleteMyselfButton_UserFragment\n  ...AuthScreenBase_UserInformationFragment\n}\n\nfragment DeleteMyselfButton_UserFragment on UserInformation {\n  isLocked\n}\n\nfragment EditRoleForm_UserInformationFragment on UserInformation {\n  id\n  roleApplicationProcess {\n    address {\n      company\n      street\n      postalCode\n      city\n      country\n    }\n    contactDetails {\n      phoneNumber\n      mobileNumber\n      faxNumber\n    }\n  }\n  userConsentsMobileMarketing\n}\n\nfragment NewsletterFormPart_BrandFragment on Brand {\n  newsletters {\n    name\n    description\n    id\n    limitToRoles\n    registrationDisplayLocations\n    countries\n  }\n}\n\nfragment NewsletterFormPart_UserInformationFragment on UserInformation {\n  signedUpToNewsletters {\n    id\n    name\n  }\n}\n\nfragment Newsletters_UserStatusFragment on UserInformation {\n  roleApplicationProcess {\n    address {\n      country\n    }\n    targetRole\n  }\n  signedUpOverBrand {\n    newsletters {\n      id\n      name\n      description\n      registrationDisplayLocations\n      countries\n      limitToRoles\n    }\n    id\n  }\n  signedUpToNewsletters {\n    id\n    name\n  }\n  newsletterSubscriptions {\n    id\n    newsletter {\n      id\n    }\n    subscribedAt\n    unsubscribedAt\n  }\n}\n\nfragment NonAuthScreenBase_BrandFragment on Brand {\n  name\n  brandColorHex\n  icon {\n    url\n    id\n  }\n}\n\nfragment RoleApplicationRegistrationForm_UserInformationFragment on UserInformation {\n  signedUpOverBrand {\n    icon {\n      url\n      id\n    }\n    availableRoles\n    id\n    brandColorHex\n    ...NewsletterFormPart_BrandFragment\n  }\n  ...NewsletterFormPart_UserInformationFragment\n}\n\nfragment RolesDisplay_UserStatusFragment on UserInformation {\n  id\n  email\n  isLocked\n  roleApplicationProcess {\n    status\n    userStatus\n    targetRole\n    address {\n      company\n      street\n      postalCode\n      city\n    }\n    contactDetails {\n      faxNumber\n      phoneNumber\n      mobileNumber\n    }\n  }\n  ...EditRoleForm_UserInformationFragment\n}\n\nfragment SupplyEfnForm_UserFragment on UserInformation {\n  id\n  efnNumber\n  isLocked\n  roleApplicationProcess {\n    targetRole\n    address {\n      country\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bd6738e0726bd4f3245de75e340008f9";

export default node;
